import React from 'react';
import { Box, Button, Container, Grid, Typography, Paper } from '@mui/material';
import { AppRoutes } from '../../routes';
import SchoolIcon from '@mui/icons-material/School';
import ScheduleIcon from '@mui/icons-material/Schedule';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { useFeatureFlagNavigation } from '../../hooks/useFeatureFlagNavigation';

const BecomeTutor: React.FC = () => {
    const { navigateTo } = useFeatureFlagNavigation();

    return (
        <Box>
            {/* Hero Section */}
            <Box
                sx={{
                    bgcolor: 'primary.main',
                    color: 'white',
                    py: 8,
                    textAlign: 'center',
                }}
            >
                <Container maxWidth="md">
                    <Typography variant="h2" component="h1" gutterBottom fontWeight="bold">
                        Share Your Knowledge, Inspire Success
                    </Typography>
                    <Typography variant="h5" component="p" gutterBottom sx={{ mb: 4, opacity: 0.9 }}>
                        Join our community of expert tutors and help students achieve their academic goals while earning on your own terms.
                    </Typography>
                    <Button
                        variant="contained"
                        color="secondary"
                        size="large"
                        onClick={() => navigateTo(AppRoutes.SIGNUP)}
                        sx={{
                            px: 4,
                            py: 1.5,
                            fontSize: '1.2rem',
                            fontWeight: 'bold',
                            borderRadius: 2,
                            textTransform: 'none'
                        }}
                    >
                        Get Started Today
                    </Button>
                </Container>
            </Box>

            {/* Benefits Section */}
            <Container maxWidth="lg" sx={{ py: 8 }}>
                <Typography variant="h3" component="h2" textAlign="center" gutterBottom sx={{ mb: 6 }}>
                    Why Tutor with YoTutor?
                </Typography>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={4}>
                        <Paper elevation={0} sx={{ p: 4, height: '100%', textAlign: 'center', bgcolor: 'grey.50' }}>
                            <ScheduleIcon color="primary" sx={{ fontSize: 60, mb: 2 }} />
                            <Typography variant="h5" component="h3" gutterBottom fontWeight="bold">
                                Flexible Schedule
                            </Typography>
                            <Typography variant="body1" color="text.secondary">
                                Set your own hours and availability. Work as much or as little as you want, fitting tutoring around your life.
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Paper elevation={0} sx={{ p: 4, height: '100%', textAlign: 'center', bgcolor: 'grey.50' }}>
                            <MonetizationOnIcon color="primary" sx={{ fontSize: 60, mb: 2 }} />
                            <Typography variant="h5" component="h3" gutterBottom fontWeight="bold">
                                Earn Competitive Rates
                            </Typography>
                            <Typography variant="body1" color="text.secondary">
                                Set your own prices and keep a significant portion of your earnings. We handle the payments so you can focus on teaching.
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Paper elevation={0} sx={{ p: 4, height: '100%', textAlign: 'center', bgcolor: 'grey.50' }}>
                            <SchoolIcon color="primary" sx={{ fontSize: 60, mb: 2 }} />
                            <Typography variant="h5" component="h3" gutterBottom fontWeight="bold">
                                Impact Students' Lives
                            </Typography>
                            <Typography variant="body1" color="text.secondary">
                                Make a real difference in students' academic journeys. Help them understand complex subjects and build confidence.
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>

            {/* CTA Section */}
            <Box sx={{ bgcolor: 'grey.100', py: 8, textAlign: 'center' }}>
                <Container maxWidth="md">
                    <Typography variant="h4" component="h2" gutterBottom>
                        Ready to become a mentor?
                    </Typography>
                    <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 4 }}>
                        Sign up now and start building your profile. It only takes a few minutes to get started.
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        onClick={() => navigateTo(AppRoutes.SIGNUP)}
                        sx={{ px: 6, py: 1.5 }}
                    >
                        Apply Now
                    </Button>
                </Container>
            </Box>
        </Box>
    );
};

export default BecomeTutor;
